import React from "react";
import ClientSlider from "../Sliders/ClientSlider";
import "../Stylings/client.css";

const Clients = () => {
  return (
    <div className="overflow-hidden w-full h-auto px-4 xl:max-w-screen-xl xl:mx-auto">
      <div>
        <h1 className="py-4 text-3xl text-center font-bold md:text-4xl md:pb-20 lg:text-5xl lg:text-gray-800">
          Our Clients Love Our Work!
        </h1>
      </div>
      <ClientSlider>
        {/* 1st Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Denzil
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (India)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Junaid got the project to closure irrespective of the challenges
              we encountered during the process since the project requirements
              weren't well elaborated by me. He's a through professional, good
              listener and efficiently translated the problem statement to code.
              It was a pleasure working with you.”
            </p>
          </div>
        </div>
        {/* 2nd Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Micheal
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (Malta)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Junaid exceeded my expectations as always, I will definitely use
              his services again 5/5”
            </p>
          </div>
        </div>
        {/* 3rd Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Tayler
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (United States)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Very very excited to have found Junaid, He is an incredible
              Developer and has so much talent - now trying to convince him to
              work full time for us. Seriously recommend him. ”
            </p>
          </div>
        </div>
        {/* 4th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              sathyamoorthyv
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (Canada)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Delivered quickly as per my request and it works well. Thanks”
            </p>
          </div>
        </div>
        {/* 5th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Ayub
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (France)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Service was so great ! The Communication was amazing , this guy
              is a real preofessional web dev who know what he's doing not like
              others out there ! final result was better than expected ! cant
              wait to work on the next project with him ! really worth it !”
            </p>
          </div>
        </div>
        {/* 6th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Ahmed
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (UK)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “From my very first message to last, the seller communicated
              everything clearly and asked all the right questions unlike others
              asking for budget. The code is very clean (easy to maintain and
              good commenting). Very quick delivery, ill be ordering again soon.
              Thanks again!!”
            </p>
          </div>
        </div>
        {/* 7th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              worldwidefame
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (Cyprus)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Perfect man for your job”
            </p>
          </div>
        </div>
        {/* 8th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              dgaa1991
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (Denmark)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “This developer is the one of a kind with great communication
              skills!”
            </p>
          </div>
        </div>
        {/* 9th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Walid
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (Belgium)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Great service, fast and responsive!”
            </p>
          </div>
        </div>
        {/* 10th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Arslan
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (Pakistan)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Junaid represents among the highest levels of customer service I
              have experienced. Information was accurate, responses to queries
              were turned around very fast. Answers were clear and where
              necessary detailed enough for us to make informed decisions
              quickly. Thanks so much we will be working with you in future.”
            </p>
          </div>
        </div>
        {/* 10th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Leo Matter
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (Italy)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Great communication skills, very good english and easy to work
              with! thanks for the excellent work and I hope we will work
              together in the future again!”
            </p>
          </div>
        </div>
        {/* 11th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Kuba
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (Poland)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Junaid is a really professional, kind and effective programmer.
              He not only is a knowledgeable programmer specialized in the
              newest technologies (React, Gatsby.js, Next.js) but also a perfect
              communicator. It really means a lot to me, since I care about
              friendly atmosphere and being productive during any project I am
              involved. And that's how our cooperation looked like – effective,
              kind and I didn't have any doubts about skills and felt secure
              about the quality of the project Junaid will deliver. Totally
              recommend him because he is not only a great programmer but also
              an awesome human being :)”
            </p>
          </div>
        </div>
        {/* 12th Client */}
        <div className="gap-8 changePadding  md:px-20  flex flex-col   justify-center items-center">
          <div className="changeWidth px-4 shadow-md gap-8    justify-center items-center">
            <h2 className="font-bold text-xl py-2 pt-4 md:text-2xl lg:text-3xl lg:text-gray-800">
              Babu
            </h2>
            <span className="text-gray-400 font-semibold text-md lg:text-lg">
              from (United Arab Emirates)
            </span>
            <p className="py-4 text-sm lg:text-lg">
              “Junaid is a very talented developer on the frontend and backend,
              he responds quickly when questions are asked and concerns are
              raised about anything. He is quick learner and does research. He
              is very polite in communication. One thing I noticed, he always
              goes above the requirements to get things done Which is
              appreciable.”
            </p>
          </div>
        </div>
      </ClientSlider>
    </div>
  );
};

export default Clients;
